import React from 'react';
import { History, RotateCcw, FileText, CheckCircle2 } from 'lucide-react';
import { StashEntry } from '../types';

interface ShadowStashViewProps {
  entries: StashEntry[];
  onRestore: (stashId: string) => void;
}

export const ShadowStashView: React.FC<ShadowStashViewProps> = ({ entries, onRestore }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border-subtle)', borderRadius: 'var(--radius-lg)', padding: '16px 20px' }}>
        <h3 style={{ fontSize: '1rem', fontWeight: 700, marginBottom: '6px', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <History size={18} color="var(--accent-blue)" />
          Automated Shadow Stash & 1-Click Rollback
        </h3>
        <p style={{ fontSize: '0.84rem', color: 'var(--text-secondary)' }}>
          Every time ChatGPT or an agent modifies a file using <code>apply_patch</code> or write operations, OpenAITunnel automatically takes an instant snapshot backup before the change. You can restore any file version with 1-click.
        </p>
      </div>

      <div className="stash-list">
        {entries.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '48px', color: 'var(--text-muted)' }}>
            No backup snapshots yet. Snapshots will appear automatically when files are modified.
          </div>
        ) : (
          entries.map((entry) => (
            <div key={entry.id} className="stash-item">
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <FileText size={20} color="var(--accent-cyan)" />
                <div>
                  <div style={{ fontWeight: 600, fontSize: '0.9rem', color: 'var(--text-primary)' }}>
                    {entry.filePath}
                  </div>
                  <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>
                    Backup: {new Date(entry.timestamp).toLocaleString()} • Size: {entry.originalSize} bytes • ID: {entry.id}
                  </div>
                </div>
              </div>

              <button
                className="btn btn-secondary"
                style={{ padding: '6px 14px', fontSize: '0.82rem' }}
                onClick={() => onRestore(entry.id)}
              >
                <RotateCcw size={14} />
                Restore Snapshot
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
